import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';
import { ProjectDetailState } from '../state';

enum ActionTypes {
  ShowSyncConfigButton = 'project/ui/showSyncConfigButton',
  HideSyncConfigButton = 'project/ui/hideSyncConfigButton',
  ShowSaveConfigButton = 'project/ui/showSaveConfigButton',
  HideSaveConfigButton = 'project/ui/hideSaveConfigButton',
}

export interface UIAction {
  type: ActionTypes;
}

export const showSyncConfigButton = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => (dispatch, getState) => {
  if (!getState().projectDetail.uiConfig.visibleSyncConfigButton) {
    dispatch({
      type: ActionTypes.ShowSyncConfigButton,
    });
  }
};

export const hideSyncConfigButton = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => (dispatch, getState) => {
  if (getState().projectDetail.uiConfig.visibleSyncConfigButton) {
    dispatch({
      type: ActionTypes.HideSyncConfigButton,
    });
  }
};

export const showSaveConfigButton = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => (dispatch, getState) => {
  if (!getState().projectDetail.uiConfig.visibleSaveConfigButton) {
    dispatch({
      type: ActionTypes.ShowSaveConfigButton,
    });
  }
};

export const hideSaveConfigButton = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => (dispatch, getState) => {
  if (getState().projectDetail.uiConfig.visibleSaveConfigButton) {
    dispatch({
      type: ActionTypes.HideSaveConfigButton,
    });
  }
};

export const UIActionDelegate: DelegateMapEntry<
  UIAction,
  ProjectDetailState
> = {
  [ActionTypes.ShowSyncConfigButton]: (
    state: ProjectDetailState,
    action: UIAction
  ): ProjectDetailState => {
    return {
      ...state,
      uiConfig: {
        ...state.uiConfig,
        visibleSyncConfigButton: true,
      },
    };
  },
  [ActionTypes.HideSyncConfigButton]: (
    state: ProjectDetailState,
    action: UIAction
  ): ProjectDetailState => {
    return {
      ...state,
      uiConfig: {
        ...state.uiConfig,
        visibleSyncConfigButton: false,
      },
    };
  },
  [ActionTypes.ShowSaveConfigButton]: (
    state: ProjectDetailState,
    action: UIAction
  ): ProjectDetailState => {
    return {
      ...state,
      uiConfig: {
        ...state.uiConfig,
        visibleSaveConfigButton: true,
      },
    };
  },
  [ActionTypes.HideSaveConfigButton]: (
    state: ProjectDetailState,
    action: UIAction
  ): ProjectDetailState => {
    return {
      ...state,
      uiConfig: {
        ...state.uiConfig,
        visibleSaveConfigButton: false,
      },
    };
  },
};
